import Button from 'components/Button';

const Submit = ({ isPending, formik, children, pendingText, validation }) => {
    return (
        <>
            {Object.keys(formik.errors).length !== 0 &&
                formik.submitCount >= 1 && (
                    <div className="small text-crimson">
                        {Object.keys(formik.errors).length !== 0 &&
                            formik.submitCount >= 1 &&
                            validation}
                    </div>
                )}
            <Button type="submit" btn_size="lg" disabled={isPending}>
                {!isPending ? `${children}` : pendingText}
            </Button>
        </>
    );
};

export default Submit;
